/**
 *  Filename ....: dw-dropdown.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/8/23
 **/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export class DataRecord {
    public id: string;
    public description: string;
    constructor(idVal: string, desc: string) {
        this.id = idVal;
        this.description = desc;
    }
}

@Component({
    selector: 'dw-dropdown',
    templateUrl: './dw-dropdown.component.html',
    styleUrls: ['./dw-dropdown.component.css']
})

export class DwDropdownComponent implements OnInit {

    public _id: string;
    public _disabled:boolean = false;
    public _dataSource: any = [];
    public _selectedItem: any;
    public Idx:number = -1;
    public _controlWidth = '120px';
    public _fontSize = '10pt';
    public  activeInactiveList: Array<DataRecord>;
    public placeholder = '-Please Select-';
    public selectionClass = 'dw-mat-select';
    @Output() itemSelected: EventEmitter<string> = new EventEmitter<string>();

    @Input() set id(value: string) {
        this._id = value;
    }
    get id(): string {
        return this._id;
    }
    @Input() set disabled(value: boolean) {
        this._disabled = value;
    }
    get disabled(): boolean {
        return this._disabled;
    }
    
     @Input() multiSelect: boolean = false;

    @Input() set placeHolder(val: string) {
        this.placeholder = val;
    }
    @Input() set useStatusOptions(val: string) {
        this.activeInactiveList = new Array<DataRecord>();

        if (val === undefined) {
            throw(new Error('Must have a value with this option'));
            return;
        }
        if (val === 'all') {
            this.activeInactiveList.push(new DataRecord('All','All'));
            this.activeInactiveList.push(new DataRecord('Active', 'Active'));
            this.activeInactiveList.push(new DataRecord('InActive', 'InActive'));
        }
        else if (val === 'status') {
            this.activeInactiveList.push(new DataRecord('Active', 'Active'));
            this.activeInactiveList.push(new DataRecord('InActive', 'InActive'));
        }
        else if (val === 'statusdiscontinuedall') {
            this.activeInactiveList.push(new DataRecord('All','All'));
            this.activeInactiveList.push(new DataRecord('Active', 'Active'));
            this.activeInactiveList.push(new DataRecord('InActive', 'InActive'));
            this.activeInactiveList.push(new DataRecord('Discontinued', 'Discontinued'));
        }
        else if (val === 'statusdiscontinued') {
            this.activeInactiveList.push(new DataRecord('Active', 'Active'));
            this.activeInactiveList.push(new DataRecord('InActive', 'InActive'));
            this.activeInactiveList.push(new DataRecord('Discontinued', 'Discontinued'));
        }
        else if (val === 'yesno') {
            this.placeholder = '--';
            this.activeInactiveList.push(new DataRecord('--', '--'));
            this.activeInactiveList.push(new DataRecord('Yes', 'Yes'));
            this.activeInactiveList.push(new DataRecord('No', 'No'));
        }
        else if (val === 'yesnoonly') {
            this.activeInactiveList.push(new DataRecord('Yes', 'Yes'));
            this.activeInactiveList.push(new DataRecord('No', 'No'));
        }
         else if (val === 'ynd') {
            this.activeInactiveList.push(new DataRecord('Yes', 'Yes'));
            this.activeInactiveList.push(new DataRecord('No', 'No'));
            this.activeInactiveList.push(new DataRecord('Does Not Apply', 'Does Not Apply'));
        }
        else if (val === 'controlType') {
            this.activeInactiveList.push(new DataRecord('YND', 'Yes / No / Does Not Apply'));
            this.activeInactiveList.push(new DataRecord('Text', 'Text'));
            this.activeInactiveList.push(new DataRecord('Number', 'Number'));
            this.activeInactiveList.push(new DataRecord('Date', 'Date'));
        }
        else if (val === 'genderItems') {
            this.activeInactiveList.push(new DataRecord('Unknown', 'Unknown'));
            this.activeInactiveList.push(new DataRecord('Male', 'Male'));
            this.activeInactiveList.push(new DataRecord('Female', 'Female'));
            this.activeInactiveList.push(new DataRecord('Other', 'Other'));
        }
         else if (val === 'andor') {
            this.activeInactiveList.push(new DataRecord('AND', 'AND'));
            this.activeInactiveList.push(new DataRecord('OR', 'OR'));
        }
        else if (val === 'readOnly') {
            this.activeInactiveList.push(new DataRecord('No Access', 'No Access'));
            this.activeInactiveList.push(new DataRecord('Read Only', 'Read Only'));
        }
        else if (val === 'readWrite') {
            this.activeInactiveList.push(new DataRecord('No Access', 'No Access'));
            this.activeInactiveList.push(new DataRecord('READ', 'Read Only'));
            this.activeInactiveList.push(new DataRecord('WRITE', 'Read Write'));
        }
        else if (val === 'execute') {
            this.activeInactiveList.push(new DataRecord('No Access', 'No Access'));
            this.activeInactiveList.push(new DataRecord('EXECUTE', 'Execute'));
        }

        else if (val === 'show') {
            this.activeInactiveList.push(new DataRecord('No Access', 'No Access'));
            this.activeInactiveList.push(new DataRecord('SHOW', 'Show'));
        }  else if (val === 'defaultmembers') {
            this.activeInactiveList.push(new DataRecord('A', 'All'));
            this.activeInactiveList.push(new DataRecord('S', 'Self'));
        }

        this.dataSource = this.activeInactiveList;
    }

    @Input() set dataSource(val: any) {
        this._dataSource = val;
    }
    get dataSource(): any {
        return this._dataSource;
    }
    @Input() set selectedItem(value: any) {
        this._selectedItem = value;

    }
    get selectedItem(): any {
        return this._selectedItem;
    }
    @Input() set controlWidth(value: any) {
        this._controlWidth = value;
    }
    get controlWidth(): any {
        return this._controlWidth;
    }

    @Input() set fontSize(value: any) {
        this._fontSize = value;
    }
    get fontSize(): any {
        return this._fontSize;
    }

    @Input() set useStyleOverride(value: boolean) {
        if (value === true) {
           this.selectionClass = 'dw-mat-select-alternate';
        }
    }
    constructor() {
    }

    ngOnInit() {
    }
    public onDropDownKeyDown(event: any): void {
        const len: number = this.dataSource.length;

        try {
            event.stopPropagation();

            if ((this.dataSource !== undefined) && (this.dataSource.length > 0)) {
                this.Idx = this.dataSource.findIndex(s => s.id === this.selectedItem);
            }
            if (event.key === 'ArrowDown') {
                if (this.Idx < (len - 1)) {
                    this.selectedItem = this.dataSource[++this.Idx].id;
                }
            } else if (event.key === 'ArrowUp') {
                if (this.Idx > 0) {
                    this.selectedItem = this.dataSource[--this.Idx].id;
                }
            } else if (event.key === 'Enter') {
                this.selectedItem = this.dataSource[this.Idx].id;
            }
        } catch (error) {
            // nothing.
        }
    }

    public onDwItemSelected(ev: any): void {
        this.selectedItem = ev.value;
        this.itemSelected.emit(ev.value);
    }
}


